import { RollbarErrorLogger } from './rollbar-error-logger';
import { CompositeLogger } from './composite-logger';
import { getRollbar } from 'client/shared/integrations/rollbar/init';

export const errorLogger = new CompositeLogger([
  new RollbarErrorLogger(getRollbar()),
]);
